if (!customElements.get('hotspot-scene')) {
  class HotspotScene extends HTMLElement {
    connectedCallback() {
      this.lastTrigger = null;
      this.addEventListener('click', this.onClick);

      this.querySelectorAll('dialog.hs-modal').forEach((dialog) => {
        // Close when the backdrop (the dialog element itself) is clicked.
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('hs-scroll-lock');
          if (this.lastTrigger) this.lastTrigger.focus();
        });
      });

      // Close any open popup when the theme's product-form adds to cart,
      // so the cart drawer isn't hidden behind the dialog.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.querySelectorAll('dialog.hs-modal[open]').forEach((dialog) => dialog.close());
        });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.unsubscribeCart?.();
    }

    onClick = (event) => {
      const target = event.target;

      const areaTrigger = target.closest('[data-hs-target]');
      if (areaTrigger) {
        this.activate(areaTrigger.dataset.hsTarget, areaTrigger);
        return;
      }

      const modalTrigger = target.closest('[data-hs-modal]');
      if (modalTrigger) {
        this.openModal(modalTrigger.dataset.hsModal, modalTrigger);
        return;
      }

      const close = target.closest('[data-hs-close]');
      if (close) {
        close.closest('dialog')?.close();
      }
    };

    activate(panelId, source) {
      this.querySelectorAll('[data-hs-target]').forEach((el) => {
        const on = el.dataset.hsTarget === panelId;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', String(on));
      });
      this.querySelectorAll('.hs__panel').forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });

      // Keep the matching mobile chip in view.
      const chip = this.querySelector(`.hs__chip[data-hs-target="${panelId}"]`);
      if (chip && chip !== source && chip.offsetParent !== null) {
        chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    openModal(id, trigger) {
      const dialog = this.querySelector(`#${CSS.escape(id)}`);
      if (!dialog) return;
      this.lastTrigger = trigger;
      document.documentElement.classList.add('hs-scroll-lock');
      dialog.showModal();
    }
  }

  customElements.define('hotspot-scene', HotspotScene);
}